// extracted by mini-css-extract-plugin
export default {"cardLayout":"jqVltz"};